import { render, staticRenderFns } from "./IconSeedling.vue?vue&type=template&id=848b8d12"
import script from "./IconSeedling.vue?vue&type=script&lang=js"
export * from "./IconSeedling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports